export const frontmatter = {
    "draft": true,
    "title": "Integración API",
    "description": "Conecta sistemas externos con OnnIA mediante la integración API.",
    "sidebar_label": "API",
    "sidebar_group": "guías",
    "sidebar_order": 3
}

export const toc = []